// Single source of truth for training-slot capacity rules on the Office App side, mirroring
// api/src/common/utils/capacity.ts exactly. Morning slots (08:00-11:00) have a lower "normal"
// capacity than afternoon/evening slots (15:00-21:00) — the Office App is allowed to manually
// push a morning slot one member past its normal capacity (an intentional staff override), but
// every slot still has the same hard ceiling of 7. Each app (api/web_office/web_user_v2) is a
// separate project, so it can't literally import one shared file — keep all three in sync if
// these numbers ever change.

export const MORNING_HOURS = [8, 9, 10, 11];
export const AFTERNOON_HOURS = [15, 16, 17, 18, 19, 20, 21];

// The hard ceiling for every slot, morning or afternoon — the Office App's own capacity checks
// (Add Member, Edit Appointment / reschedule) must always compare against this, never against a
// slot's own max_bookings (6 for morning), otherwise the override below could never be reached.
export const ABSOLUTE_CAPACITY = 7;

const MORNING_NORMAL_CAPACITY = 6;

export function isMorningHour(hour) {
  return MORNING_HOURS.includes(hour);
}

// { normalCapacity, absoluteCapacity, officeOverrideAllowed } for the given hour (0-23).
export function getSlotCapacityRules(hour) {
  if (isMorningHour(hour)) {
    return {
      normalCapacity: MORNING_NORMAL_CAPACITY,
      absoluteCapacity: ABSOLUTE_CAPACITY,
      officeOverrideAllowed: true,
    };
  }

  return {
    normalCapacity: ABSOLUTE_CAPACITY,
    absoluteCapacity: ABSOLUTE_CAPACITY,
    officeOverrideAllowed: false,
  };
}

// Whether the Office App can still add/move one more member into a slot that already has
// `usedBookings` people in it — always gated by the absolute ceiling (7), not the slot's own
// max_bookings, so the morning override (6 -> 7) stays reachable from every Office App entry
// point (New Appointment, Edit Appointment / reschedule).
export function canOfficeAddMember(usedBookings) {
  return (usedBookings ?? 0) < ABSOLUTE_CAPACITY;
}
